import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-date-picker";
import moment from "moment";
import Crop from "../../shared/crop";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const Add = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState("");
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const [categoryDrp, setCategoryDrpData] = useState([]);
  const [sizeDrp, setSizeDrpData] = useState([]);
  const [seriesDrp, setSeriesDrpData] = useState([]);
  const [subcategoryDrp, setSubCategoryDrpData] = useState([]);
  const [specsData, setSpecsData] = useState([]);
  // const [supplierDrp, setSupplierDrp] = useState([]);
  // const [invoiceDate, setInvoiceDate] = useState();
  const [formData, setFormData] = useState({
    name: "",
    unit: "",
    hsn_code: "",
    size_id: "",
    supplier_id: "1",
    series_id: [],
    weight: "",
    category_id: null,
    sub_category_id: null,
    gst: "",
    image: "",
    image_preview: "",
    // opening_stock: "",
    // opening_stock_date: null,
    covered_area: "",
    pcs_per_box: "",
  });

  // const getSupplier = () => {
  //   axios.post(API_URL.SUPPLIERS_LIST, {}).then(
  //     (res) => {
  //       if (res.data.status === 1) {
  //         let cd = res.data.data.map((caw) => {
  //           return {
  //             label: caw.name,
  //             value: caw.id,
  //           };
  //         });
  //         setSupplierDrp(cd);
  //       }
  //       setLoading(false);
  //     },
  //     (error) => {
  //       setLoading(false);
  //       toast.error("Something went wrong..", {
  //         autoClose: 3000,
  //       });
  //     }
  //   );
  // };

  const getCategoryDrpData = () => {
    axios.post(API_URL.CATEGORY_LIST, {}).then((res) => {
      setCategoryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCategoryDrpData(cd);
    });
  };

  const getSubCategoryDrpData = () => {
    axios
      .post(API_URL.SUB_CATEGORY_LIST, { category_id: formData.category_id })
      .then((res) => {
        setSubCategoryDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setSubCategoryDrpData(cd);
      });
  };

  const getSpecsData = () => {
    axios
      .post(API_URL.SPECS_LIST, {
        category_id: formData.category_id,
        product_id: id ? id : null,
      })
      .then((res) => {
        if (res.data.status === 1) {
          let specs = res.data.data.map((row) => {
            return {
              specs_id: row.id,
              specs_name: row.name,
              specs_value: row.specs_value ? row.specs_value : "",
            };
          });
          setSpecsData(specs);
        }
      });
  };

  const getSizeData = () => {
    axios.post(API_URL.SIZE_LIST, {}).then((res) => {
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setSizeDrpData(cd);
    });
  };

  const getSeriesData = () => {
    axios.post(API_URL.SERIES_LIST, {}).then((res) => {
      setSeriesDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setSeriesDrpData(cd);
    });
  };
const onSave = () => {
  if (
    formData.name &&
    formData.unit &&
    formData.weight &&
    formData.category_id &&
    formData.sub_category_id &&
    formData.hsn_code &&
    formData.size_id &&
    (id ? true : formData.image) && // required only on add
    formData.gst &&
    formData.series_id &&
    formData.covered_area &&
    formData.pcs_per_box
  ) {
    setError(false);
    setLoading(true);
    let payload = { ...formData };
    payload.specs = specsData;
    payload.supplier_id = "1";
    const pUrl = id ? API_URL.PRODUCT_UPDATE : API_URL.PRODUCT_SAVE;
    axios.post(pUrl, payload)
      .then((res) => {
        if (res.data.status === 1) {
          let message = id
            ? "Product Updated Successfully."
            : "Product Created Successfully.";
          toast.success(message, { autoClose: 3000, position: "top-right" });
          navigate("/product");
        }
      })
      .finally(() => {
        setLoading(false);
        setError(true);
      });
  } else {
    setLoading(false);
    setError(true);
  }
};

  const onEdit = () => {
    axios.post(API_URL.PRODUCT_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          unit: res.data.data.unit ? res.data.data.unit : "",
          weight: res.data.data.weight ? res.data.data.weight : "",
          category_id: res.data.data.category_id
            ? res.data.data.category_id
            : "",
          sub_category_id: res.data.data.sub_category_id
            ? res.data.data.sub_category_id
            : "",
          hsn_code: res.data.data.hsn_code ? res.data.data.hsn_code : "",
          size_id: res.data.data.size_id ? res.data.data.size_id : "",
          series_id: res.data.data.series_id ? res.data.data.series_id : [],
          gst: res.data.data.gst ? res.data.data.gst : "",
          covered_area: res.data.data.covered_area || "",
          pcs_per_box: res.data.data.pcs_per_box || ""
        });
        // if (res.data.data.opening_stock_date) {
        //   setInvoiceDate(new Date(res.data.data.opening_stock_date));
        // }
        if (res.data.data.image) {
          setImagePreview(res.data.data.image);
        }
        if (res.data.data.image_preview) {
          setPreviewImage(res.data.data.image_preview);
        }
      }
    });
  };

  const getLatest = () => {
    axios.post(API_URL.PRODUCT_LATEST, {}).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: null,
          name: "",
          unit: res.data.data.unit ? res.data.data.unit : "",
          weight: res.data.data.weight ? res.data.data.weight : "",
          category_id: res.data.data.category_id
            ? res.data.data.category_id
            : "",
          sub_category_id: res.data.data.sub_category_id
            ? res.data.data.sub_category_id
            : "",
          hsn_code: res.data.data.hsn_code ? res.data.data.hsn_code : "",
          size_id: res.data.data.size_id ? res.data.data.size_id : "",
          // supplier_id: res.data.data.supplier_id
          //   ? res.data.data.supplier_id
          //   : "",
          series_id: res.data.data.series_id ? res.data.data.series_id : [],
          gst: res.data.data.gst ? res.data.data.gst : "",
          covered_area: res.data.data.covered_area
            ? res.data.data.covered_area
            : "",
          pcs_per_box: res.data.data.pcs_per_box
            ? res.data.data.pcs_per_box
            : "",
          // opening_stock: "",
          // opening_stock_date: null,
          image: "",
          image_preview: "",
        });
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formData[key];
  };

  const isRequiredsField = (key) => {
    return isError && (!formData[key] || formData[key]?.length === 0);
  };

  const updateSpecs = (evt, key) => {
    let specsCp = [...specsData];
    specsCp[key].specs_value = evt.target.value;
    setSpecsData(specsCp);
  };

  useEffect(() => {
    getSizeData();
    getSeriesData();
    getCategoryDrpData();
    // getSupplier();
  }, []);

  useEffect(() => {
    if (formData.category_id) {
      getSubCategoryDrpData();
      getSpecsData();
    }
  }, [formData.category_id]);

  useEffect(() => {
    if (id) {
      onEdit();
    } else {
      getLatest();
    }
  }, [id]);

  const options = [
    { value: "Box", label: "Box" },
    { value: "Pcs", label: "Pcs" },
    { value: "Nos", label: "Nos" },
    { value: "Bag", label: "Bag" },
    { value: "Kg", label: "Kg" },
    { value: "Pkt", label: "Pkt" },
    { value: "Bottle", label: "Bottle" },
  ];

  const GstOptions = [
    { value: "0", label: "0%" },
    { value: "5", label: "5%" },
    { value: "12", label: "12%" },
    { value: "18", label: "18%" },
    { value: "28", label: "28%" },
  ];

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Product</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/product"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <form onSubmit={(event) => event.preventDefault()}>
              <div className="row">
                <div className="col-md-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>
                          Image<span className="required-star">*</span>
                        </label>
                        <div
                          className={isRequiredField("image") && "required-box"}
                        >
                          <div>
                            <Crop
                              imagePreview={imagePreview}
                              cropShape={"round"}
                              guid={""}
                              width={250}
                              height={250}
                              onChangeCropper={async ({
                                fileCroppedBase64,
                              }) => {
                                setFormData({
                                  ...formData,
                                  image: fileCroppedBase64,
                                });
                                setImagePreview(fileCroppedBase64);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Preview Image</label>
                        <div
                          className={isRequiredField("previewimage") && "required-box"}
                        >
                          <Crop
                            imagePreview={previewimage}
                            cropShape={"round"}
                            guid={""}
                            width={250}
                            height={125}
                            aspectRatio={'BLOG'}
                            onChangeCropper={async ({
                              fileCroppedBase64,
                            }) => {
                              setFormData({
                                ...formData,
                                image_preview: fileCroppedBase64,
                              });
                              setPreviewImage(fileCroppedBase64);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="col-md-9">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>
                          Name<span className="required-star">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          maxLength={100}
                          value={formData.name}
                          className={
                            isRequiredField("name")
                              ? "form-control required"
                              : "form-control"
                          }
                          id="name"
                          onChange={(event) => {
                            setFormData({
                              ...formData,
                              name: event.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>
                          HSN Code<span className="required-star">*</span>
                        </label>
                        <input
                          type="text"
                          maxLength={30}
                          name="hsn_code"
                          value={formData.hsn_code}
                          className={
                            isRequiredField("hsn_code")
                              ? "form-control required"
                              : "form-control"
                          }
                          id="hsn_code"
                          onChange={(event) => {
                            setFormData({
                              ...formData,
                              hsn_code: event.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>
                          Weight (Unit in KG)
                          <span className="required-star">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          maxLength={10}
                          value={formData.weight}
                          className={
                            isRequiredField("weight")
                              ? "form-control required"
                              : "form-control"
                          }
                          id="weight"
                          onChange={(event) => {
                            setFormData({
                              ...formData,
                              weight: event.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Covered Area (Sqft per Box)<span className="required-star">*</span></label>
                        <input
                          type="text"
                          maxLength={20}
                          value={formData.covered_area}
                          className={isRequiredField("covered_area") ? "form-control required" : "form-control"}
                          onChange={(e) => setFormData({ ...formData, covered_area: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Pcs per Box<span className="required-star">*</span></label>
                        <input
                          type="number"
                          maxLength={10}
                          value={formData.pcs_per_box}
                          className={isRequiredField("pcs_per_box") ? "form-control required" : "form-control"}
                          onChange={(e) => setFormData({ ...formData, pcs_per_box: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="Category">Category</label>
                        <Select
                          options={categoryDrp}
                          value={categoryDrp.find(
                            (r) => r.value == formData.category_id
                          )}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              category_id: e.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="SubCategory">Sub Category</label>
                        <Select
                          options={subcategoryDrp}
                          value={subcategoryDrp.find(
                            (r) => r.value == formData.sub_category_id
                          )}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sub_category_id: e.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="Size">
                          Size<span className="required-star">*</span>
                        </label>
                        <Select
                          options={sizeDrp}
                          value={sizeDrp.find(
                            (r) => r.value == formData.size_id
                          )}
                          styles={
                            isRequiredField("size_id")
                              ? customRequireStyles
                              : customStyles
                          }
                          onChange={(e) =>
                            setFormData({ ...formData, size_id: e.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>
                          Unit<span className="required-star">*</span>
                        </label>
                        <Select
                          options={options}
                          styles={
                            isRequiredField("unit")
                              ? customRequireStyles
                              : customStyles
                          }
                          value={options.find((r) => r.value == formData.unit)}
                          onChange={(e) =>
                            setFormData({ ...formData, unit: e.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="form-group">
                        <label htmlFor="Series">
                          Series<span className="required-star">*</span>
                        </label>
                        <Select
                          options={seriesDrp}
                          value={formData.series_id}
                          isMulti={true}
                          styles={
                            isRequiredsField("series_id")
                              ? customRequireStyles
                              : customStyles
                          }
                          onChange={(e) =>
                            setFormData({ ...formData, series_id: e })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Gst</label>
                        <Select
                          options={GstOptions}
                          value={GstOptions.find(
                            (r) => r.value == formData.gst
                          )}
                          onChange={(e) =>
                            setFormData({ ...formData, gst: e.value })
                          }
                        />
                      </div>
                    </div>
                    {/* <div className="col-md-4">
                      <div className="form-group">
                        <label>Opening Stock</label>
                        <input
                          type="text"
                          name="opening_stock"
                          maxLength={30}
                          value={formData.opening_stock}
                          className="form-control" id="opening_stock"
                          onChange={(event) => {
                            setFormData({ ...formData, opening_stock: event.target.value });
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="">Opening Stock Date</label>
                        <DatePicker
                          format={"dd/MM/y"}
                          className="form-control"
                          onChange={setInvoiceDate}
                          value={invoiceDate}
                        />
                      </div>
                    </div> */}
                    {specsData.map((control, key) => {
                      return (
                        <div key={key} className="col-md-4">
                          <div className="form-group">
                            <label>{control.specs_name}</label>
                            <input
                              type="text"
                              name={control.specs_id}
                              maxLength={100}
                              value={control.specs_value}
                              className="form-control"
                              onChange={(event) => {
                                updateSpecs(event, key);
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={onSave}
                      disabled={loading}
                      className="btn btn-primary"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Add;
